import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../hooks/useAdminAuth';
import './AdminLogin.css';

const AdminLogin: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [cargando, setCargando] = useState(false);
  const { login } = useAdminAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setCargando(true);
    try {
      await login(email, password);
      navigate('/admin/empresas', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al iniciar sesion');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <div className="admin-login-icon">
            <i className="fas fa-shield-alt"></i>
          </div>
          <h1>VacationSystem</h1>
          <p>Panel de Administracion</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          {error && (
            <div className="admin-login-error">
              <i className="fas fa-exclamation-circle"></i>
              <span>{error}</span>
            </div>
          )}

          <div className="admin-form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="superadmin@vacationsystem.com"
              required
              disabled={cargando}
              autoFocus
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="password">Contraseña</label>
            <div className="admin-password-wrapper">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                disabled={cargando}
              />
              <button
                type="button"
                className="admin-eye-btn"
                tabIndex={-1}
                onClick={() => setShowPassword(v => !v)}
              >
                <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
              </button>
            </div>
          </div>

          <button type="submit" className="admin-login-btn" disabled={cargando}>
            {cargando ? (
              <><div className="admin-spinner"></div> Ingresando...</>
            ) : (
              <><i className="fas fa-sign-in-alt"></i> Ingresar</>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
